var styles = {"inputLabel":"styles_input-label__Rbhud","dark":"styles_dark__-kxkm","disabled":"styles_disabled__-qJl3"};

export { styles as default };
//# sourceMappingURL=styles.css.js.map
